import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import kknext from '@/icons/kk-next.vue';
import kkprev from '@/icons/kk-prev.vue';
import kkmail from '@/icons/kk-mail.vue';
import kkmenudown from '@/icons/kk-menu-down.vue';

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: 'mdi',
    icons: {
        values: {
            kknext: {
                component: kknext,
            },
            kkprev: {
                component: kkprev,
            },
            kkmail: {
                component: kkmail,
                props: {
                    color: '#2969e8',
                },
            },
            kkmenudown: {
                component: kkmenudown,
            },
        },
    },
    breakpoint: {
        thresholds: {
            xs: 769,
            sm: 1081,
            md: 1441,
            lg: 1921,
        },
    },
    theme: {
        themes: {
            light: {
                primary: '#2969e8',
            },
            dark: {
                primary: '#2969e8',
            },
        },
        options: {
            customProperties: true,
        },
    },
});
